import { useArticleTypes } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useArticleTypes';
import { useCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCart';

export const useCartItemState = ({ items, index }) => {
  const { cart } = useCart();
  const { defaultFormItem, requiredArticleTypes, getSelectableArticleTypes } = useArticleTypes();

  const isNewCartItem = items[index].price === undefined;

  const autoOpenDialog = isNewCartItem && requiredArticleTypes.includes(defaultFormItem.type);

  const initialFormItem = isNewCartItem ? defaultFormItem : cart?.items[index]?.toFormItem() || defaultFormItem;

  return {
    initialFormItem,
    isNewCartItem,
    autoOpenDialog,
    selectableArticleTypes: getSelectableArticleTypes(index),
  };
};
